export default "__VITE_ASSET__Dl6Dfhej__"